export default __webpack_public_path__ + "static/media/filip-vasicek.f32b9c25.jpg";